import {
  Text,
  View,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
  TextInput,
  FlatList,
  StatusBar,
  Dimensions,
  Image,
  useWindowDimensions
} from 'react-native'
import { Ionicons } from '@expo/vector-icons'
import * as React from 'react'
// styles
import { colorPalette, globalStyles } from '../../static/styles/global'
// screens & components
import UserBar from '../../components/user/UserBar'
import Card from '../../components/shared/card/Card'
import moment from 'moment'
import { Entypo } from '@expo/vector-icons'
import Modal from 'react-native-modal'
import { useEffect, useState } from 'react'
import Calendar_Stripe from '../../components/shared/calendar/calender_strip'
import axios from 'axios'
import { TabView, SceneMap, TabBar } from 'react-native-tab-view'
import CardSeparator from '../../components/shared/card/CardSeparator'
import CustomButton from '../../components/shared/button/Button'
import HelpScreen from '../home/HelpScreen'

const MessageNew = ({ navigation }): JSX.Element => {
  const [isModalVisible, setIsModalVisible] = React.useState(false)
  const handleModal = () => setIsModalVisible(() => !isModalVisible)
  const [isContact, setContact] = React.useState('')
  const { width: DEVICE_WIDTH } = useWindowDimensions()

  const showContacts = () => {
    console.log('Show Contacts')
  }
  const addContact = (contact) => {
    //console.log(contact)
    setContact(contact)
    handleModal()
  }
  return (
    <ScrollView>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View
          style={[
            globalStyles.hDirection,
            globalStyles.vCenterItems,
            globalStyles.hBetweenItems,
            globalStyles.mb3
          ]}
        >
          <TouchableOpacity
            style={[
              globalStyles.hDirection,
              globalStyles.vCenterItems,
              globalStyles.flexOne
            ]}
            onPress={() => {
              navigation.navigate('Messages')
            }}
          >
            <View style={[globalStyles.relativePosition, globalStyles.ln6]}>
              <Ionicons
                name="chevron-back"
                size={24}
                color={colorPalette.white}
              />
            </View>

            <Text style={[globalStyles.text, globalStyles.whiteTextColor]}>
              {'Messages'}
            </Text>
          </TouchableOpacity>
        </View>
        <View style={{ marginTop: 20, marginBottom: 0 }}>
          <Text
            style={{
              color: 'white',
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: 24
            }}
          >
            New Message
          </Text>
        </View>
      </View>
      <View style={[globalStyles.containerOverlap]}>
        <Card>
          <View
            style={{
              flex: 1,
              flexDirection: 'row',
              paddingVertical: 5,
              paddingHorizontal: 10
            }}
          >
            <TextInput
              placeholder="To:"
              style={[globalStyles.customInput, { flex: 1 }]}
              value={isContact}
            />
            <Entypo
              name="plus"
              onPress={handleModal}
              size={24}
              style={{ position: 'absolute', right: 10 }}
            />
          </View>
          <View
            style={{
              flexDirection: 'column',
              height: Dimensions.get('window').height - 250
            }}
          >
            <View style={[globalStyles.mt2]}>
              <TextInput
                placeholder="Add Subject(required)"
                style={[globalStyles.customInput]}
              />
            </View>
            <View></View>
          </View>
          <View
            style={{
              flex: 1,
              flexDirection: 'row',
              paddingVertical: 5,
              paddingHorizontal: 10
            }}
          >
            <TextInput
              placeholder="Message"
              style={[globalStyles.customInputBorder, { flex: 1 }]}
            />
            <Entypo
              name="direction"
              size={24}
              style={{ position: 'absolute', right: 20, top: 10 }}
            />
          </View>
        </Card>
      </View>
      <View>
        <Modal isVisible={isModalVisible}>
          <View
            style={{
              backgroundColor: '#f1f1f1',
              padding: 20,
              marginLeft: DEVICE_WIDTH > 960 ? '60%' : '0%',
              width: DEVICE_WIDTH > 960 ? '40%' : '100%',
              borderRadius: 10,
              borderColor: '#00756E',
              borderWidth: 1
            }}
          >
            <View style={{ flex: 1, flexDirection: 'row' }}>
              <View
                style={{
                  backgroundColor: '#00756E',
                  width: '40%',
                  padding: 10,
                  top: -20,
                  left: '25%',
                  borderBottomRightRadius: 10,
                  borderBottomLeftRadius: 10
                }}
              >
                <Text
                  style={{
                    color: '#fff',
                    fontSize: 16,
                    fontWeight: 'bold',
                    flex: 1,
                    textAlign: 'center'
                  }}
                >
                  Contacts
                </Text>
              </View>
              <Entypo
                name="cross"
                size={24}
                style={{ flex: 1, textAlign: 'right', marginTop: -10 }}
                onPress={handleModal}
              />
            </View>
            <View>
              <View
                style={{ borderBottomColor: '#c3c3c3', borderBottomWidth: 1 }}
              >
                <Text
                  style={{ paddingTop: 10, paddingBottom: 10, fontSize: 18 }}
                  onPress={() => addContact('Human Resource Management')}
                >
                  Human Resource Department
                </Text>
              </View>
              <View
                style={{ borderBottomColor: '#c3c3c3', borderBottomWidth: 1 }}
              >
                <Text
                  style={{ paddingTop: 10, paddingBottom: 10, fontSize: 18 }}
                  onPress={() => addContact('Bakery Department')}
                >
                  Bakery Department
                </Text>
              </View>
              <View
                style={{ borderBottomColor: '#c3c3c3', borderBottomWidth: 1 }}
              >
                <Text
                  style={{ paddingTop: 10, paddingBottom: 10, fontSize: 18 }}
                  onPress={() => addContact('Security')}
                >
                  Security
                </Text>
              </View>
              <View
                style={{ borderBottomColor: '#c3c3c3', borderBottomWidth: 1 }}
              >
                <Text
                  style={{ paddingTop: 10, paddingBottom: 10, fontSize: 18 }}
                  onPress={() => addContact('Manager')}
                >
                  Manager
                </Text>
              </View>
              <View
                style={{ borderBottomColor: '#c3c3c3', borderBottomWidth: 1 }}
              >
                <Text
                  style={{ paddingTop: 10, paddingBottom: 10, fontSize: 18 }}
                  onPress={() => addContact('Dairy')}
                >
                  Dairy
                </Text>
              </View>
            </View>
          </View>
        </Modal>
      </View>
    </ScrollView>
  )
}
const styles = StyleSheet.create({
  custom: {
    justifyContent: 'center',
    flexDirection: 'row',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 16,
    paddingRight: 16,
    alignItems: 'center',
    backgroundColor: '#0088CF',
    color: 'black',
    borderWidth: 0,
    width: '90%',
    marginTop: 10
  },
  customCardHeader: {
    justifyContent: 'center',
    flexDirection: 'row',
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 16,
    paddingRight: 16,
    alignItems: 'center',
    backgroundColor: '#0088CF',
    borderWidth: 0,
    width: '60%',
    marginTop: -18
  },
  myCard: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    backgroundColor: '#1978cd',
    marginBottom: 20,
    borderRadius: 5
  },
  dangerColor: {
    color: 'red',
    fontSize: 14
  },
  dayClass: {
    justifyContent: 'center',
    padding: 18
  },
  dayActive: {
    width: 6,
    height: 6,
    backgroundColor: 'black',
    borderRadius: 10,
    left: 2,
    marginTop: 10
  },
  container: {
    flex: 1,
    padding: 10
  },
  tabBar: {
    flexDirection: 'row',
    paddingTop: StatusBar.currentHeight
  },
  tabItem: {
    flex: 1,
    alignItems: 'center',
    padding: 0,
    backgroundColor: 'green'
  },
  pd10: {
    padding: 10
  },
  CardProfile: {
    backgroundColor: colorPalette.light,
    padding: 16,
    borderRadius: 8
  },
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 25,
    width: '100%',
    height: '100%',
    backgroundColor: '#EAF2F5'
  },

  modalLargeScreen: {
    maxWidth: '50%',
    right: 0,
    position: 'absolute',
    width: '100%',
    height: '100%'
  }
})
export default MessageNew
